// extracted by mini-css-extract-plugin
export default {"orbvpntext":"OrbVpnText_orbvpntext__TLC8W","textrow":"OrbVpnText_textrow__pHQJ4","textcol":"OrbVpnText_textcol__d0chr"};